export default {
      id: "icon--quickbook-usage",
      viewBox: "0 0 30.5 31.3",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--quickbook-usage",
      toString: function () {
        return this.url;
      }
    }